import { render, staticRenderFns } from "./InitioFormulate.vue?vue&type=template&id=72559206&"
import script from "./InitioFormulate.vue?vue&type=script&lang=js&"
export * from "./InitioFormulate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports